// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.specific-strategies-error {
  margin: 0.75rem auto;
  color: #b91c1c;
  font-size: 0.9rem;
  text-align: center;
}

.dark .specific-strategies-error {
  color: #fca5a5;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/strategies/SpecificStrategiesPracticePane.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".specific-strategies-error {\n  margin: 0.75rem auto;\n  color: #b91c1c;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.dark .specific-strategies-error {\n  color: #fca5a5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
